export enum FuncionalidadesCivico {
  VisualizarDashboard = 29,
  CadastrarFatoAluno = 30,
  ExcluirFatoAluno = 31,
  EditarFatoAluno = 32,
  AprovarEdicaoFatoAluno = 33,
}
